"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
const needle_1 = __importDefault(require("needle"));
const lodash_1 = require("lodash");
const company_1 = __importDefault(require("./company"));
const ip_1 = __importDefault(require("./ip"));
const errors_1 = require("./errors");
const pkg = require("../package.json");
const DEFAULT_HOST = "bigpicture.io";
const TIMEOUT = 10000;
class Client {
    constructor(key, config = {}) {
        this.key = key;
        this.host = DEFAULT_HOST;
        this.Company = new company_1.default(this);
        this.Ip = new ip_1.default(this);
        if (lodash_1.isNil(this.key)) {
            throw new Error("API key is not defined");
        }
    }
    _request(options) {
        var timeout = options.timeout || TIMEOUT;
        return needle_1.default(options.method, options.url, options.body || options.query, {
            timeout: timeout,
            headers: {
                Authorization: this.key,
            },
            user_agent: "BigPictureNode/v" + pkg.version,
        }).then(function (res) {
            if (res.statusCode === 200) {
                return res.body;
            }
            else if (res.statusCode === 202) {
                throw new errors_1.QueuedError(res.body);
            }
            else if (res.statusCode === 404) {
                throw new errors_1.NotFoundError(res.body);
            }
            else if (res.statusCode === 400) {
                throw new errors_1.BadRequestError(res.body);
            }
            else if (res.statusCode === 429) {
                throw new errors_1.RateLimitError(res.body);
            }
            else if (res.statusCode >= 500) {
                throw new errors_1.UnknownError(res.body);
            }
        });
    }
    _buildUrl(subdomain, path, version) {
        return `https://${subdomain}.${this.host}/v${version}${path}`;
    }
}
exports.Client = Client;
//# sourceMappingURL=client.js.map